import component from '../../styles/objects/component'

export default component



// WEBPACK FOOTER //
// ./components/select/styles.js